/**
 * Applies the filter panel's default "Created On" date filter to rows
 * already loaded, for listings whose search API has no date range of its
 * own. `dateStart` / `dateEnd` are YYYY-MM-DD and inclusive; a row's date is
 * compared by its calendar day.
 */
export function filterByCreatedOn<T>(
  rows: T[] | null | undefined,
  filters: { dateStart?: unknown; dateEnd?: unknown } | null | undefined,
  getDate: (row: T) => string | null | undefined = (row) =>
    (row as { creationDate?: string | null }).creationDate,
): T[] {
  const list = rows ?? [];
  const from = typeof filters?.dateStart === "string" ? filters.dateStart : "";
  const to = typeof filters?.dateEnd === "string" ? filters.dateEnd : "";
  if (!from && !to) return list;
  return list.filter((row) => {
    const day = (getDate(row) || "").slice(0, 10);
    if (!day) return false;
    if (from && day < from) return false;
    if (to && day > to) return false;
    return true;
  });
}
